var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClientPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 73,
    viewBox: "0 0 58 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w6j1h3do9a",
    d: "M0 0.677L56.164 0.677 56.164 71.314 0 71.314z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5) translate(0 .022)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mk9v674hob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w6j1h3do9a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M45.849 47.944C33.848 66.294 16.149 75.82 6.343 69.22c-9.817-6.59-8.044-26.82 3.97-45.172 12.012-18.344 29.7-27.88 39.508-21.281 9.817 6.593 8.044 26.82-3.972 45.176",
    mask: "url(#mk9v674hob)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#11110F",
    d: "M27.992 48.147c0 1.822-1.476 3.302-3.299 3.302-1.82 0-3.3-1.48-3.3-3.302 0-1.823 1.48-3.3 3.3-3.3 1.823 0 3.3 1.477 3.3 3.3",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M19.97 29.497c0 1.492.443 2.698 1.352 3.68.883.959 1.954 1.424 3.271 1.424 1.318 0 2.389-.465 3.273-1.424.91-.982 1.353-2.188 1.353-3.68 0-.708-.199-1.358-.605-1.986-.418-.653-.973-1.157-1.695-1.541-.725-.39-1.484-.578-2.326-.578-.838 0-1.6.188-2.324.578-.72.384-1.276.89-1.697 1.54-.404.63-.602 1.28-.602 1.987m-.338 5.24c-1.304-1.408-1.96-3.17-1.96-5.24 0-1.148.325-2.237.968-3.234.627-.974 1.485-1.754 2.544-2.322 2.102-1.127 4.716-1.127 6.82 0 1.059.568 1.916 1.348 2.544 2.322.644.997.97 2.086.97 3.234 0 2.067-.66 3.831-1.962 5.24-1.324 1.436-2.994 2.163-4.963 2.163-1.966 0-3.637-.727-4.96-2.162M37.23 47.516l.196 1.922c.062.631-.396 1.197-1.03 1.259-.623.054-1.197-.395-1.26-1.026l-.195-1.921c-.207-2.003-1.114-3.494-2.775-4.556-1.76-1.123-4.276-1.693-7.48-1.693-3.203 0-5.717.573-7.478 1.7-1.663 1.064-2.571 2.56-2.778 4.565l-.194 1.905c-.06.592-.56 1.03-1.144 1.03-.038 0-.077 0-.118-.004-.631-.062-1.091-.63-1.027-1.26l.197-1.908c.277-2.71 1.565-4.816 3.823-6.266 2.136-1.368 5.07-2.062 8.72-2.062 3.649 0 6.58.693 8.72 2.054 2.256 1.442 3.544 3.548 3.823 6.261",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M47.647 19.129c.504-.472 1.295-.446 1.766.058.44.47.448 1.19.037 1.668l-.095.099-9.843 9.216c-.496.464-1.262.443-1.733-.024l-.09-.099-4.168-5.115c-.436-.535-.356-1.322.18-1.758.5-.407 1.218-.364 1.667.078l.091.101 3.321 4.076 8.867-8.3z",
    transform: "translate(.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClientPending);
export default __webpack_public_path__ + "static/media/icon_client_pending.f1beaa414967ac637b0ab6c2f351fe7a.svg";
export { ForwardRef as ReactComponent };